import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsEmailNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        clipRule="evenodd"
        d="M.5 6.876c0-1.188 1.082-2.063 2.3-2.063h18.4c1.218 0 2.3.875 2.3 2.063v10.248c0 1.188-1.082 2.064-2.3 2.064H2.8c-1.218 0-2.3-.876-2.3-2.064zm1.318-.291l9.566 5.796c.368.223.864.223 1.232 0l9.566-5.796c-.138-.316-.496-.575-.982-.575H2.8c-.486 0-.844.26-.982.575zm20.428 1.38l-8.958 5.428a2.524 2.524 0 01-2.576 0L1.755 7.965v9.16c0 .43.415.865 1.045.865h18.4c.63 0 1.046-.436 1.046-.866z"
        fill=""
        fillRule="evenodd"
      />
    </svg>
  )
);
SvgActionsEmailNormalSmall.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgActionsEmailNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsEmailNormalSmall;
